import "./style.scss";

import { FlyoutContent } from "@amzn/stencil-react-components/flyout";
import { Col } from "@amzn/stencil-react-components/layout";
import { ITOConsumers } from "common/types";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";

import { MessagesView } from "./OrderMessagesViews/MessagesView";
import { NoMessagesView } from "./OrderMessagesViews/NoMessagesView";
import { useOrderMessages } from "./useOrderMessages";

/**
 * Represents the properties for the OrderMessagesFlyout component.
 *
 * @interface
 * @property {() => void} onClose - Callback invoked when the flyout is closed.
 * @property {string} title - Title displayed at the top of the flyout.
 * @property {boolean} [isSupportRequested] - Indicator that support has already been requested for this order.
 * @property {string} orderTaxId - Taxonomy ID of the order for message operations.
 * @property {string} orderReference - Order reference.
 */
interface OrderMessagesFlyoutProps {
  onClose: () => void;
  title: string;
  isSupportRequested?: boolean;
  orderTaxId: string;
  orderReference: string;
}

export const OrderMessagesFlyout: FC<OrderMessagesFlyoutProps> = ({
  onClose,
  title,
  isSupportRequested,
  orderTaxId,
  orderReference,
}) => {
  // Hook
  const { messages, submitComment, isLoading, isSubmitting, hasError } = useOrderMessages(
    ITOConsumers.AMZNHAM,
    orderTaxId
  );

  return (
    <FlyoutContent
      titleText={getString("orderMessages.orderMessagesTitle")}
      onCloseButtonClick={onClose}
      maxWidth="600px"
    >
      <Col>
        {isSupportRequested ? (
          <MessagesView
            title={title}
            messages={messages}
            order={orderTaxId}
            orderReference={orderReference}
            submitComment={submitComment}
            isLoading={isLoading}
            isSubmitting={isSubmitting}
            hasError={hasError}
          />
        ) : (
          <NoMessagesView />
        )}
      </Col>
    </FlyoutContent>
  );
};
